import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const BusinessPlusSubscriptionCard: Illustration = (props) => (
  <svg viewBox="0 0 289 107" {...illustrationProps(props, { width: 289 })}>
    <path
      d="M223.449 23.9961C217.502 23.9961 212.68 28.7691 212.68 34.6569V54.5237L202.827 62.1866C201.219 63.4376 202.113 65.9953 204.158 65.9953L277.23 65.9961C283.178 65.9961 288 61.2231 288 55.3353V34.6568C288 28.7691 283.178 23.9961 277.23 23.9961H223.449Z"
      fill="#B8E682"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M226 37.4232C226 35.5305 227.531 33.9961 229.42 33.9961H235.933C237.822 33.9961 239.353 35.5305 239.353 37.4232V52.8685C239.353 54.7612 237.822 56.2956 235.933 56.2956H229.42C227.531 56.2956 226 54.7612 226 52.8685V37.4232ZM229.42 37.4232H235.933V43.6942H229.42V37.4232ZM229.42 47.1213V52.8685H235.933V47.1213H229.42Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M243.354 37.4232C243.354 35.5305 244.885 33.9961 246.774 33.9961H253.286C255.175 33.9961 256.707 35.5305 256.707 37.4232V52.8685C256.707 54.7612 255.175 56.2956 253.286 56.2956H246.774C244.885 56.2956 243.354 54.7612 243.354 52.8685V37.4232ZM246.774 37.4232H253.286V43.6942H246.774V37.4232ZM246.774 47.1213V52.8685H253.286V47.1213H246.774Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M264.127 33.9961C262.238 33.9961 260.707 35.5305 260.707 37.4232V52.8685C260.707 54.7612 262.238 56.2956 264.127 56.2956H270.64C272.529 56.2956 274.06 54.7612 274.06 52.8685V37.4232C274.06 35.5305 272.529 33.9961 270.64 33.9961H264.127ZM270.64 37.4232H264.127V43.6942H270.64V37.4232ZM264.127 52.8685V47.1213H270.64V52.8685H264.127Z"
      fill="white"
    />
    <path
      d="M65.5505 11.9961C71.4984 11.9961 76.3202 16.7691 76.3202 22.6569V51.5237L86.1726 59.1866C87.781 60.4376 86.8874 62.9953 84.8418 62.9953L17.7696 62.9961C11.8217 62.9961 7 58.2231 7 52.3353V22.6568C7 16.7691 11.8217 11.9961 17.7696 11.9961H65.5505Z"
      fill="#76C82E"
    />
    <path
      d="M37.2575 38.3263C41.2328 40.2998 46.1805 39.2836 49.0206 35.655C52.2664 31.508 51.5302 25.5192 47.3764 22.2788C43.2226 19.0383 37.224 19.7732 33.9782 23.9202C30.7324 28.0672 31.4685 34.056 35.6224 37.2964C36.1416 37.7015 36.6896 38.0444 37.2575 38.3263Z"
      fill="white"
    />
    <path
      d="M24.8719 51.5649C26.0141 45.7635 31.1008 41.5807 37.0136 41.5807H46.319C52.2683 41.5807 57.342 45.8898 58.3052 51.7606C58.6691 53.9789 56.9573 55.9945 54.7093 55.9945H28.5144C26.1763 55.9945 24.4203 53.859 24.8719 51.5649Z"
      fill="white"
    />
    <path
      d="M73.3697 76.3603C71.3147 83.6827 69.2706 91.0021 67.2157 98.3246C66.9202 99.3762 66.6247 100.428 66.3293 101.479C65.8074 103.352 68.6723 104.082 69.1982 102.202C71.2532 94.88 73.2973 87.5606 75.3522 80.2382C75.6477 79.1865 75.9432 78.1349 76.2386 77.0833C76.7605 75.2107 73.8956 74.4808 73.3697 76.3603Z"
      fill="#FFB3B3"
    />
    <path
      d="M59.6239 87.6266C66.7437 89.4783 73.8566 91.326 80.9763 93.1777C81.9716 93.435 82.967 93.6923 83.9583 93.9566C85.7994 94.4315 86.5774 91.5126 84.7336 91.0268C77.6138 89.1751 70.5009 87.3274 63.3812 85.4757C62.3859 85.2184 61.3905 84.9611 60.3992 84.6968C58.5581 84.2219 57.78 87.1407 59.6239 87.6266Z"
      fill="#FFB3B3"
    />
    <path
      d="M81.7749 80.7919C75.2533 84.6126 68.7426 88.4303 62.2211 92.251C61.2869 92.8034 60.35 93.3448 59.4159 93.8972C57.7436 94.8819 59.1907 97.4804 60.863 96.4958C67.3846 92.675 73.8953 88.8574 80.4168 85.0366C81.3509 84.4842 82.2879 83.9428 83.222 83.3904C84.8942 82.4058 83.4471 79.8072 81.7749 80.7919Z"
      fill="#FFB3B3"
    />
    <path
      d="M64.3931 79.0532C68.0302 85.5001 71.6565 91.9501 75.2937 98.397L76.8148 101.104C77.752 102.773 80.3435 101.246 79.4064 99.5766C75.7801 93.1266 72.1429 86.6797 68.5166 80.2298L66.9955 77.5232C66.0583 75.8534 63.4668 77.3804 64.4039 79.0502L64.3931 79.0532Z"
      fill="#FFB3B3"
    />
    <path
      d="M215.816 10.0321C215.947 8.7217 215.614 7.3486 214.833 6.41272C214.081 5.51704 212.832 5.10117 211.74 4.97821C211.03 4.89737 210.385 4.94289 209.711 5.28956C209.193 5.55447 208.764 5.99628 208.43 6.51729C207.867 6.61674 207.426 7.0666 207.201 7.72541C206.798 8.90047 206.905 10.2164 207.36 11.3009C207.485 11.9053 207.724 12.4395 208.159 12.847C208.624 13.2844 209.145 13.6149 209.706 13.8671C210.896 14.4003 212.352 14.8688 213.622 14.1008C214.121 13.798 214.451 13.331 214.656 12.7883C214.76 12.6825 214.854 12.5743 214.94 12.4639C215.47 11.7392 215.722 10.9333 215.816 10.0321ZM210.957 9.16266C210.957 9.16266 210.98 9.14654 210.957 9.16266V9.16266Z"
      fill="#FFB3B3"
    />
    <path
      d="M107.64 20.5247C108.493 17.3823 111.732 15.5266 114.875 16.3799L190.301 36.8618C193.443 37.7151 195.299 40.9543 194.446 44.0967L182.607 87.6941C181.753 90.8365 178.514 92.6921 175.372 91.8388L99.9457 71.3569C96.8033 70.5036 94.9476 67.2645 95.8009 64.1221L107.64 20.5247Z"
      fill="#4D5BE0"
    />
    <path
      d="M108.478 58.6576C107.035 58.2421 105.673 58.9771 105.435 60.2992C105.198 61.6213 106.175 63.0299 107.618 63.4454C109.629 64.0244 114.1 65.2029 115.442 65.5422C116.893 65.9087 118.218 65.1224 118.403 63.7859C118.587 62.4494 117.56 61.0688 116.109 60.7023C114.799 60.3713 110.399 59.2109 108.478 58.6576Z"
      fill="#7C7FFF"
    />
    <path
      d="M126.178 63.4003C124.735 62.9848 123.373 63.7198 123.135 65.0419C122.898 66.364 123.875 67.7726 125.318 68.1881C127.329 68.7671 131.8 69.9456 133.143 70.2849C134.593 70.6515 135.919 69.8652 136.103 68.5287C136.287 67.1922 135.26 65.8116 133.81 65.445C132.5 65.114 128.099 63.9537 126.178 63.4003Z"
      fill="#7C7FFF"
    />
    <path
      d="M140.835 69.7847C141.073 68.4626 142.435 67.7276 143.878 68.143C145.8 68.6964 150.2 69.8568 151.51 70.1878C152.96 70.5543 153.987 71.9349 153.803 73.2714C153.619 74.6079 152.293 75.3942 150.843 75.0277C149.5 74.6883 145.029 73.5099 143.018 72.9308C141.575 72.5154 140.598 71.1068 140.835 69.7847Z"
      fill="#7C7FFF"
    />
    <path
      d="M161.578 72.8858C160.135 72.4703 158.773 73.2053 158.536 74.5274C158.298 75.8495 159.275 77.2581 160.718 77.6736C162.729 78.2526 167.2 79.4311 168.543 79.7704C169.993 80.137 171.319 79.3506 171.503 78.0141C171.687 76.6776 170.66 75.2971 169.21 74.9305C167.9 74.5995 163.5 73.4391 161.578 72.8858Z"
      fill="#7C7FFF"
    />
    <path
      d="M110.533 38.5024C110.93 36.9234 112.532 35.9653 114.111 36.3624L121.418 38.2C122.997 38.5971 123.955 40.1989 123.558 41.7779L121.72 49.0851C121.323 50.6641 119.721 51.6222 118.143 51.2251L110.835 49.3875C109.256 48.9904 108.298 47.3886 108.695 45.8096L110.533 38.5024Z"
      fill="white"
    />
  </svg>
);
